import React, {
  useEffect,
  useRef,
  useState,
} from 'react';
import { connect } from 'react-redux';
import cx from 'classnames';

import Btn from '../global/button';
import Loading from '../global/loading-screen';

import TranslatedCopy from '../../intl/translated-copy';

const mapStateToProps = state => {
  return ({
    loadingPorfileRequestStart: state.UserProfileSession.loadingPorfileRequestStart,
    metrixEmailCopy: state.UserProfileSession.metrixEmailCopy,
    profileOtpSettings: state.Manage.profileOtpSettings,
  });
};

export const hideEmail = (email) => {
  return email.replace(/(.{2})(.*)(?=@)/,
    (gp1, gp2, gp3) => {
      for (let i = 0; i < gp3.length; i++) {
        gp2 += '*';
      } return gp2;
    }
  );
};

const FormOtpLogin = (props) => {
  const {
    emailCopy,
    errorCopyId,
    handleBackButtonClick,
    handleButtonSubmitClick,
    handleCheckOtpCode,
    handleClick,
    handleOtpValidSubmit,
    isOtpSuccess,
    loadingPorfileRequestStart,
    metrixEmailCopy,
    profileOtpSettings: {
      recoverOtpSettingsLoading,
    },
    showErrorAndHideButton,
  } = props;

  const inputs = useRef(Array(6).fill(''));
  const [buttonInvalid, setButtonInvalid] = useState(true);
  const [enteredOtp, setEnteredOtp] = useState('');
  const emailMasked = emailCopy || metrixEmailCopy;
  const maskedEmail = hideEmail(emailMasked);
  const showErrorMsg = showErrorAndHideButton && errorCopyId;

  useEffect(() => {
    if (isOtpSuccess) {
      setTimeout(() => {
        handleOtpValidSubmit();
      }, 1000);
    }
  }, [isOtpSuccess]);

  const inputsClasses = cx('otp', {
    'otp-filled': showErrorAndHideButton ? isOtpSuccess && buttonInvalid === false : buttonInvalid === false,
    'otp-error': showErrorMsg,
  });

  const showLoading = Boolean(loadingPorfileRequestStart || recoverOtpSettingsLoading);

  const OtpLoginForm = cx({
    'form-otpLogin-container': true,
    'LoadingSigUpModalForm': showLoading,
  });

  const OtpSubmitBtn = cx('otp-login-submitBtn', {
    'not-login': showErrorAndHideButton,
  });

  const otpResendClasses = cx({
    'otp-resend': true,
    'otp-resend-removeMargin': showErrorAndHideButton,
  });

  const isInputsFilled = () => {
    return !inputs.current.some((element) => element.value === '');
  };

  const validateAlphaNumeric = (value) => {
    const alphanumericRegex = /^[A-Za-z0-9]+$/;
    return alphanumericRegex.test(value);
  };

  const checkOTPCode = () => {
    let enteredOtp = '';

    inputs.current.map((dataValue) => {
      enteredOtp += dataValue?.value;
    });

    setEnteredOtp(enteredOtp);
  };

  const handleInputChange = (event, index) => {
    const { value } = event.target;
    inputs.current[index].classList.add('otp-value');

    setButtonInvalid(true);

    if (!validateAlphaNumeric(value) && value.length > 0) {
      event.target.value = '';
      return;
    }

    if (value.length === 0) {
      inputs.current[index].classList.remove('otp-value');
    }

    if (value.length === 0 && index > 0) {
      inputs.current[index - 1].focus();
    } else if (value.length === 1 && index < inputs.current.length - 1) {
      inputs.current[index + 1].focus();
    }

    if (isInputsFilled()) {
      checkOTPCode();
      setButtonInvalid(false);
    }
  };

  const handleSubmit = () => {
    if (showErrorAndHideButton) {
      handleCheckOtpCode(enteredOtp);
    }
    if (!buttonInvalid && !showErrorAndHideButton) {
      handleButtonSubmitClick(enteredOtp);
    }
  };

  const handlePaste = (event, index) => {
    const clipboardData = event.clipboardData || window.clipboardData;
    const pastedText = clipboardData.getData('text');

    if (validateAlphaNumeric(pastedText)) {
      inputs.current[index].value = pastedText.charAt(0);
      let remainingValue = pastedText.slice(1);
      let i = index + 1;
      while (remainingValue.length > 0 && i < inputs.current.length) {
        inputs.current[i].value = remainingValue.charAt(0);
        remainingValue = remainingValue.slice(1);
        inputs.current[i].focus();
        i++;
      }
    }

    if (isInputsFilled()) {
      checkOTPCode();
      setButtonInvalid(false);
    }
  };

  return (
    <div className={ OtpLoginForm }>
      { showLoading &&
        <Loading
          seatmap={ true }
          isDataLoading={ true }
          type='airplaneWindow' />
      }
      <button
        className='otp-backButton'
        onClick={ handleBackButtonClick } >
        <span className='Icon Icon--calendarArrowLeft' />
        <TranslatedCopy
          className='copy-backButton'
          copyID='PRO_HOME2.0_RETURN' />
      </button>
      <div>
        <TranslatedCopy
          className='otp-title'
          copyID='PRO_HOME_LOGIN_OTP_TITLE'
          tagName='div' />
        <div className='otp-subtitle'>
          <TranslatedCopy
            copyID='PRO_HOME_LOGIN_OTP_DESCRIPTION'
            email_id={ maskedEmail } />
        </div>
        <TranslatedCopy
          className='otp-minute'
          copyID='PRO_HOME_LOGIN_OTP_TIME'
          tagName='div' />
      </div>
      <div className='container-inputs-otp'>
        { inputs.current.map((input, index) => (
          <input
            className={ inputsClasses }
            key={ index }
            maxLength={ 1 }
            onChange={ (event) => handleInputChange(event, index) }
            onPaste={ (event) => handlePaste(event, index) }
            ref={ (ref) => (inputs.current[index] = ref) }
            type='text' />
        )) }
      </div>
      { showErrorMsg &&
        <TranslatedCopy
          className='otp-text-error'
          copyID={ errorCopyId } />
      }
      <button
        className={ otpResendClasses }
        onClick={ () => handleClick() }>
        <TranslatedCopy
          copyID='PRO_HOME_LOGIN_OTP_RESEND' />
      </button>
      <div className={ OtpSubmitBtn }>
        <Btn
          block={ true }
          btnType='submit'
          copyID='PRO_HOME_LOGIN_OTP_BUTTON'
          filled={ true }
          onBtnClick={ () => handleSubmit() }
          visuallyDisabled={ buttonInvalid } />
      </div>
    </div>
  );
};

export default connect(mapStateToProps)(FormOtpLogin);
